import { EMPTY_SCAFFOLD_SELECTION } from "../interface";
import { IScaffoldActionColClicked, ScaffoldState } from "./interface";
import {
  addColRangeToSelection,
  setColRangeSelection,
  toggleColInSelection,
} from "./scaffoldSelection";

/**
 * Handles the COL_CLICKED action by updating the selection state based on the
 * modifier keys held during the click.
 *
 * - Shift+click with a column anchor: range-selects from the anchor to the clicked column.
 * - Ctrl/Meta+click: toggles the clicked column in the selection and sets the anchor.
 * - Plain click: selects only the clicked column and sets the anchor.
 *
 * @param action - The COL_CLICKED action carrying the column ID and modifier keys.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the new selection and anchor.
 */
export const scr_colClicked = <T>(
  action: IScaffoldActionColClicked,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  const { colId, ctrlKey, metaKey, shiftKey } = action;
  const { selection, selectionAnchor, prevCols } = state;

  if (shiftKey) {
    if (selectionAnchor && selectionAnchor.type === "col") {
      return {
        ...state,
        selection:
          ctrlKey || metaKey
            ? addColRangeToSelection(selection, prevCols, selectionAnchor.colId, colId)
            : setColRangeSelection(prevCols, selectionAnchor.colId, colId),
      };
    }
    return {
      ...state,
      selection: { ...EMPTY_SCAFFOLD_SELECTION, selectedCols: [{ firstCellId: colId }] },
      selectionAnchor: { type: "col", colId },
    };
  }
  return {
    ...state,
    selection:
      ctrlKey || metaKey
        ? toggleColInSelection(selection, colId)
        : { ...EMPTY_SCAFFOLD_SELECTION, selectedCols: [{ firstCellId: colId }] },
    selectionAnchor: { type: "col", colId },
  };
};
